<template>
  <span class="icon" v-html='icons[icon]' :class='"icon-"+icon'></span>
</template>
<script>
const icons = {
  'chevron-left': 
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24">\
        <path fill="#000000" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />\
    </svg>',
  // ************************
  'account-circle': 
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24">\
      <path fill="#000000" d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" />\
    </svg>',
  // ************************
  'check': 
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24">\
      <path fill="#000000" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />\
    </svg>',
  // ************************
  'loading': 
    '<svg style="width:24px;height:30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">\
      <rect x="0" y="0" width="4" height="10" fill="#333">\
        <animateTransform attributeType="xml"\
          attributeName="transform" type="translate"\
          values="0 0; 0 20; 0 0"\
          begin="0" dur="0.6s" repeatCount="indefinite" />\
      </rect>\
      <rect x="10" y="0" width="4" height="10" fill="#333">\
        <animateTransform attributeType="xml"\
          attributeName="transform" type="translate"\
          values="0 0; 0 20; 0 0"\
          begin="0.2s" dur="0.6s" repeatCount="indefinite" />\
      </rect>\
      <rect x="20" y="0" width="4" height="10" fill="#333">\
        <animateTransform attributeType="xml"\
          attributeName="transform" type="translate"\
          values="0 0; 0 20; 0 0"\
          begin="0.4s" dur="0.6s" repeatCount="indefinite" />\
      </rect>\
    </svg>',
  // ************************
  'chevron-right': 
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24">\
      <path fill="#000000" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />\
    </svg>',
  // ************************
  'camera': 
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24">\
      <path fill="#000000" d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z" />\
    </svg>',
  'open-in-app': 
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24">\
      <path fill="#000000" d="M12,10L8,14H11V20H13V14H16M19,4H5C3.89,4 3,4.9 3,6V18A2,2 0 0,0 5,20H9V18H5V8H19V18H15V20H19A2,2 0 0,0 21,18V6A2,2 0 0,0 19,4Z" />\
    </svg>',
  'timetable': 
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24">\
      <path fill="#000000" d="M14,12H15.5V14.82L17.94,16.23L17.19,17.53L14,15.69V12M4,2H18A2,2 0 0,1 20,4V10.1C21.24,11.36 22,13.09 22,15A7,7 0 0,1 15,22C13.09,22 11.36,21.24 10.1,20H4A2,2 0 0,1 2,18V4A2,2 0 0,1 4,2M4,15V18H8.67C8.24,17.09 8,16.07 8,15H4M4,8H10V5H4V8M18,8V5H12V8H18M4,13H8.29C8.63,11.85 9.26,10.82 10.1,10H4V13M15,10.15A4.85,4.85 0 0,0 10.15,15C10.15,17.68 12.32,19.85 15,19.85A4.85,4.85 0 0,0 19.85,15C19.85,12.32 17.68,10.15 15,10.15Z" />\
    </svg>',
  'calendar-multiple': 
    '<svg style="width:24px;height:24px" viewBox="0 0 24 24">\
      <path fill="#000000" d="M21,17V8H7V17H21M21,3A2,2 0 0,1 23,5V17A2,2 0 0,1 21,19H7C5.89,19 5,18.1 5,17V5A2,2 0 0,1 7,3H8V1H10V3H18V1H20V3H21M3,21H17V23H3C1.89,23 1,22.1 1,21V9H3V21M19,15H15V11H19V15Z" />\
    </svg>',


}
export default {
  name: 'Icon',
  props: ['icon'],
  data: ()=> Object({icons: icons}),
}
</script>
<style lang='scss'>
.icon {
  display: inline-block;
  vertical-align: middle;
  svg {
    display: block;
    height: 1em !important;
    width: auto !important;
  }
}
</style>